export const Months = [
  { id: 1, label: "Janeiro" },
  { id: 2, label: "Fevereiro" },
  { id: 3, label: "Março" },
  { id: 4, label: "Abril" },
  { id: 5, label: "Maio" },
  { id: 6, label: "Junho" },
  { id: 7, label: "Julho" },
  { id: 8, label: "Agosto" },
  { id: 9, label: "Setembro" },
  { id: 10, label: "Outubro" },
  { id: 11, label: "Novembro" },
  { id: 12, label: "Dezembro" }
];
